import React from "react";
import CustomerProductList from "../ProductList/CustomerProductList";
import VideoPlaylist from "../VideoPlaylist/VideoPlaylist";
import ScrollingBanner from "../ScrollingBanner/ScrollingBanner";
import HeroCarousel from "../HeroCarousel/HeroCarousel";
import "./Home.scss";

const Home = () => {
  return (
    <div className="home-container">
      <HeroCarousel />
      
      <ScrollingBanner />
      
      <div className="products-section" id="products">
        <CustomerProductList />
      </div>
      
      <VideoPlaylist />
    </div>
  );
};

export default Home;
